(function () {
  // Initialize swipe/dots for all QLF multicolumn sections that have swipe enabled
  var sections = document.querySelectorAll('.section-qlf-multicolumn .multicolumn.swipe-on-mobile');
  if (!sections.length) return;

  sections.forEach(function (section) {
    // Prevent double-initialization
    if (section.__qlfSwipeInit) return;
    section.__qlfSwipeInit = true;

    var row = section.querySelector('.multicolumn__inner .row');
    if (!row) return;

    var slides = Array.prototype.slice.call(section.querySelectorAll('.multicolumn__column'));
    if (slides.length <= 1) return;

    var dotsMount = section.querySelector('[data-dots]');
    if (!dotsMount) return;

    // Do not mount twice
    if (dotsMount.querySelector('.flickity-page-dots')) return;

    var ol = document.createElement('ol');
    ol.className = 'flickity-page-dots dot-style--dots';

    slides.forEach(function (slide, i) {
      var li = document.createElement('li');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'dot';
      btn.setAttribute('aria-label', i + 1 + ' / ' + slides.length);
      btn.addEventListener('click', function () {
        // Smoothly scroll the horizontal container without affecting vertical page position
        var rowRect = row.getBoundingClientRect();
        var slideRect = slide.getBoundingClientRect();
        var targetLeft = slideRect.left - rowRect.left + row.scrollLeft;
        try {
          row.scrollTo({ left: targetLeft, behavior: 'smooth' });
        } catch (e) {
          row.scrollLeft = targetLeft;
        }
      });
      li.appendChild(btn);
      ol.appendChild(li);
    });

    dotsMount.appendChild(ol);

    var rAF =
      window.requestAnimationFrame ||
      function (cb) {
        return setTimeout(cb, 16);
      };

    function updateActive() {
      var containerLeft = row.getBoundingClientRect().left;
      var nearest = 0;
      var min = Infinity;
      slides.forEach(function (slide, i) {
        var rect = slide.getBoundingClientRect();
        var dist = Math.abs(rect.left - containerLeft);
        if (dist < min) {
          min = dist;
          nearest = i;
        }
      });
      var dots = ol.querySelectorAll('.dot');
      dots.forEach(function (d, i) {
        d.classList.toggle('is-selected', i === nearest);
      });
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      rAF(function () {
        ticking = false;
        updateActive();
      });
    }

    row.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', updateActive);
    updateActive();
  });
})();
